"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _customerCouponConfig = _interopRequireDefault(require("./customerCouponConfig"));
var _index = _interopRequireDefault(require("./customerCouponRule/index.vue"));
var _couponRuleAdd = _interopRequireDefault(require("./customerCouponRule/couponRuleAdd.vue"));
var _index2 = _interopRequireDefault(require("./customerCouponStoreNum/index.vue"));
var _index3 = _interopRequireDefault(require("./customerCouponeSend/index.vue"));
var _index4 = _interopRequireDefault(require("./customerCouponeRecordUsed/index.vue"));
var _index5 = _interopRequireDefault(require("./customerPaperCouponeSend/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import authOrg from './authOrg/index.vue'
var _default = exports.default = {
  name: '客诉券',
  components: {
    customerCouponConfig: _customerCouponConfig.default,
    customerCouponRule: _index.default,
    couponRuleAdd: _couponRuleAdd.default,
    customerCouponStoreNum: _index2.default,
    customerCouponeSend: _index3.default,
    customerCouponeRecordUsed: _index4.default,
    customerPaperCouponeSend: _index5.default
    // authOrg,
  },
  data: function data() {
    return {
      refresh: 0,
      actTitle: null,
      ruleId: null,
      issueCode: null,
      storeName: null,
      loading: false,
      activeTab: 'customerCouponRule',
      tabs: ['customerCouponConfig', 'customerCouponRule', 'customerCouponeSend', 'customerCouponeRecordUsed', 'customerPaperCouponeSend']
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    saved: function saved() {
      this.activeTab = 'customerCouponRule';
      this.refresh = new Date().getTime();
    },
    couponRuleAdd: function couponRuleAdd() {
      this.activeTab = 'couponRuleAdd';
      this.ruleId = null; // 新增时清空
    },
    handleEdit: function handleEdit(row) {
      this.activeTab = 'couponRuleAdd';
      this.ruleId = row.id;
    },
    couponSendLog: function couponSendLog(row) {
      this.activeTab = 'customerCouponeSend';
      this.storeName = row.storeName;
    },
    couponSendLogInfo: function couponSendLogInfo(row) {
      this.activeTab = 'customerCouponeSend';
      this.storeId = row.storeId;
      this.recordId = row.id;
    },
    customerCouponeRecordUsed: function customerCouponeRecordUsed(row) {
      this.activeTab = 'customerCouponeRecordUsed';
      this.issueCode = row.issueCode;
      console.log(this.issueCode);
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
      this.ruleId = null;
    }
  }
};